import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { UploadService } from '../upload/upload.service';
import { UserService } from 'src/app/services/user/user.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import AppConstants, {file_upload_error} from '../../shared/common-components/AppConstants';
import { Router } from '@angular/router';

@Component({
    selector: 'app-upload-image',
    templateUrl: './upload-image.component.html',
    styleUrls: ['./upload-image.component.css'],
    standalone: false
})
export class UploadImageComponent implements OnInit {
  @Input() businessType;
  @Output() uploadedImage = new EventEmitter<any>();
 // businessType : any;
  private file: File = null;
  messageValue: any = "";
  fileUpload = {status: '', message: this.messageValue};
  uploadImageForm: UntypedFormGroup;
  showDownload: boolean;
  private maxFileSizeInBytes: number = 1073741824 * 3; // 1.07*10^9 bytes in a gigabyte, times 3 = 3 gigabytes
  uploadTitle: any;
  observer$ = new BehaviorSubject(true);
  

  constructor(private uploadService: UploadService, private userService: UserService, private router: Router,
    private fb: UntypedFormBuilder, private alertService: AlertService) { }

  ngOnInit(): void {
    this.uploadImageForm = this.fb.group({
      filePicker: new UntypedFormControl('', Validators.required)
    });
    
  }
  businessTypeChange(event: any){
    this.businessType = event;
  }
  fInput(e) {
    this.file = e.target.files[0];
  }
  upload() {
    if (AppConstants.isNotNullCondition(this.fileUpload.message) && this.fileUpload.message === file_upload_error) {
        this.alertService.info(file_upload_error);
        return;
    }
    if (AppConstants.isNotNullCondition(this.file)) {
      this.uploadService.postImage(this.file, this.businessType).subscribe(
          result => {
            this.fileUpload = result;
            setTimeout(() => {
              this.file = null;
              this.uploadImageForm.get('filePicker').setValue('');
              this.uploadImageForm.get('filePicker').setValidators([Validators.required]);
              this.uploadedImage.emit(true);
            }, 2500);
          },
          error => {
            console.log(error);
            this.fileUpload = {status: 'error', message: error.name + ': ' + error.message};
            this.uploadedImage.emit(false);
          }
      );
    } else {
      this.alertService.info('please select a file before upload!');
    }
  }
}
